/* global gdAlertify */
import React, { useState, useEffect, useCallback, useMemo } from "react";
import axiosInstance from "../config/axiosConfig"; // Asegúrate de importar correctamente tu instancia de Axios.
import { Grid, _ } from 'gridjs-react';
import { gridOptions } from "../utils/gridOptions";
import { formatDate } from "../utils/utils";
import { calculateAge } from "../utils/utils";
import GdTable from "./components/GdTable";
import EditarAuxiliarModal from "./CalendarioTurnos/components/EditarAuxiliarModal";
import VacacionesModal from "./components/VacacionesModal";
import ExportarAuxiliaresModal from "./components/ExportarAuxiliaresModal";
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const clasificacionMap = {
    0: '',
    1: 'Básico 0',
    2: 'Básico 0-1',
    3: 'Básico 1',
    4: 'Básico 1-2',
    5: 'Básico 2',
    6: 'Básico 2-3',
    7: 'Básico 3',
    8: 'D',
};

const formatMoney = (value) => {
    return Number(value || 0).toLocaleString("es-CL", {
        maximumFractionDigits: 0,
    });
};

const getValorTurnoActual = (row = {}) => Number(
    row.valorTurnoRt ||
    row.reemplazoValorTurno ||
    row.reemplazoValor ||
    row.valorTurno ||
    0
);

const getValorMovilizacionActual = (row = {}) => {
    if (row.reemplazoValor > 0 && row.es_reemplazo == 0) {
        return Number(row.reemplazoValorMovilizacion ?? row.valorLocomocionRt ?? row.valorMovilizacion ?? 0);
    }

    return Number(
        row.valorLocomocionRt ??
        row.reemplazoValorMovilizacion ??
        row.valorMovilizacion ??
        row.valorLocomocion ??
        0
    );
};

const getValorColacionActual = (row = {}) => {
    if (row.reemplazoValor > 0 && row.es_reemplazo == 0) {
        return Number(row.reemplazoValorColacion ?? row.valorColacionRt ?? row.valorColacion ?? 0);
    }

    return Number(
        row.valorColacionRt ??
        row.reemplazoValorColacion ??
        row.valorColacion ??
        0
    );
};

const getValorOtroActual = (row = {}) => Number(
    row.valorOtroRt ??
    row.reemplazoValorOtro ??
    row.valorOtro ??
    0
);

const getTotalTurnoAuxiliar = (row = {}) =>
    getValorTurnoActual(row) + getValorColacionActual(row) + getValorMovilizacionActual(row) + getValorOtroActual(row);

const monthOptions = [
    { value: "", label: "Todos" },
    { value: "01", label: "Enero" },
    { value: "02", label: "Febrero" },
    { value: "03", label: "Marzo" },
    { value: "04", label: "Abril" },
    { value: "05", label: "Mayo" },
    { value: "06", label: "Junio" },
    { value: "07", label: "Julio" },
    { value: "08", label: "Agosto" },
    { value: "09", label: "Septiembre" },
    { value: "10", label: "Octubre" },
    { value: "11", label: "Noviembre" },
    { value: "12", label: "Diciembre" },
];

const monthNames = {
    "01": "Enero",
    "02": "Febrero",
    "03": "Marzo",
    "04": "Abril",
    "05": "Mayo",
    "06": "Junio",
    "07": "Julio",
    "08": "Agosto",
    "09": "Septiembre",
    "10": "Octubre",
    "11": "Noviembre",
    "12": "Diciembre",
};

const getPeriodoRango = (periodo) => {
    if (!periodo) return "-";
    const [yearStr, monthStr] = periodo.split("-");
    const year = Number(yearStr);
    const monthIndex = Number(monthStr) - 1;
    const desde = new Date(year, monthIndex - 1, 26);
    const hasta = new Date(year, monthIndex, 25);
    const fmt = (date) => [
        String(date.getDate()).padStart(2, "0"),
        String(date.getMonth() + 1).padStart(2, "0"),
        date.getFullYear(),
    ].join("-");
    return `${fmt(desde)} al ${fmt(hasta)}`;
};

const diaMap = {
    Monday: "Lunes",
    Tuesday: "Martes",
    Wednesday: "Miercoles",
    Thursday: "Jueves",
    Friday: "Viernes",
    Saturday: "Sabado",
    Sunday: "Domingo",
};

const DetalleAuxiliar = ({ isOpen, onClose, details, observaciones }) => {
    const columns2 = [
        { name: "idAcuerdo", title: "ID", width: 100 },
        { name: 'paciente', title: 'Nombre paciente', width: 200 },
        { name: 'fechaInicio', title: 'Fecha Inicio', render: (row) => formatDate(row.fechaInicio), width: 200 },
        { name: 'fechaFin', title: 'Fecha Fin', render: (row) => formatDate(row.fechaFin), width: 100 },
        { name: "estado", title: "Estado", render: (row) => row.estado === 1 ? 'Activo' : 'Cerrado', width: 100 },
    ]
    const columns3 = [
        { name: "observacionID", title: "ID", width: 100 },
        { name: 'fecha', title: 'Fecha', render: (row) => formatDate(row.fecha), width: 100 },
        { name: 'observacion', title: 'Observación', width: 300 }
    ]
    if (!isOpen) return null;
    return (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="userDetailsModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl">
                <div className="modal-content">
                    <div className="modal-body">
                        <h3>Historial de acuerdos mutuos</h3>
                        {details ? (
                            <GdTable
                                columns={columns2}
                                data={details}
                                defaultItemsPerPage={100}
                                itemsPerPageOptions={[5, 10, 25, 50, 100]}
                                initialSort={[0, "asc"]}
                                exportFilename="nomina-auxiliares-detalle.xlsx"
                            />
                        ) : (
                            <p>Cargando...</p>
                        )}
                        <h3>Observaciones</h3>
                        {details ? (
                            <GdTable
                                columns={columns3}
                                data={observaciones}
                                defaultItemsPerPage={100}
                                itemsPerPageOptions={[5, 10, 25, 50, 100]}
                                initialSort={[0, "asc"]}
                                exportFilename="nomina-auxiliares-observaciones.xlsx"
                            />
                        ) : (
                            <p>Cargando...</p>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
};
const ObservationModal = ({ isOpen, onClose, auxiliarID }) => {
    const [observation, setObservation] = useState("");

    if (!isOpen) return null;

    const handleSaveObservation = async () => {
        console.log("Enviando observación para auxiliarID:", auxiliarID);
        console.log("Observación:", observation);
        if (!auxiliarID || observation == "") {
            gdAlertify.notiError("Debe ingresar una observación");
            return;
        }

        try {
            const response = await axiosInstance.post("/auxiliar/observaciones/guardar", {
                auxiliarID,
                observacion: observation,
            });

            if (response.data.error) {
                gdAlertify.notiError(response.data.message);
                return;
            }

            gdAlertify.notiSuccess(response.data.message);
            setObservation("");
            onClose();
        } catch (error) {
            console.error("Error al guardar la observación:", error);
            gdAlertify.notiError("Hubo un error al guardar la observación.");
        }
    };

    return (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="observationModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="observationModalLabel">Agregar Observación</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <label htmlFor="observationInput" className="form-label">Observación</label>
                        <textarea
                            id="observationInput"
                            className="form-control"
                            rows="4"
                            value={observation}
                            onChange={(e) => setObservation(e.target.value)} // Actualiza el estado
                        />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                        <button type="button" className="btn btn-primary" onClick={handleSaveObservation}>Guardar</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const HistorialRetirosModal = ({ isOpen, onClose, auxiliar, historial, loading }) => {
    if (!isOpen) return null;

    const retiros = Array.isArray(historial)
        ? historial.filter((item) => item.tipo_evento === "RETIRO")
        : [];

    return (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="historialRetirosModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="historialRetirosModalLabel">
                            Historial de retiros {auxiliar?.nombreAuxiliar ? `- ${auxiliar.nombreAuxiliar}` : ""}
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        {loading ? (
                            <p>Cargando...</p>
                        ) : retiros.length > 0 ? (
                            <div className="table-responsive">
                                <table className="table table-sm table-striped align-middle">
                                    <thead>
                                        <tr>
                                            <th>Fecha retiro</th>
                                            <th>Fecha anterior</th>
                                            <th>Registrado por</th>
                                            <th>Fecha registro</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {retiros.map((item) => (
                                            <tr key={item.id}>
                                                <td>{formatDate(item.fecha_evento)}</td>
                                                <td>{item.fecha_anterior ? formatDate(item.fecha_anterior) : "-"}</td>
                                                <td>{item.usuario_nombre || "Sistema"}</td>
                                                <td>{formatDate(item.fecha_registro)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : (
                            <p className="mb-0 text-muted">No hay retiros registrados para este auxiliar.</p>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const ResumenAnualTurnosModal = ({ isOpen, onClose, auxiliar }) => {
    const currentYear = new Date().getFullYear();
    const [anio, setAnio] = useState(currentYear);
    const [mes, setMes] = useState("");
    const [periodoDesde, setPeriodoDesde] = useState("");
    const [periodoHasta, setPeriodoHasta] = useState("");
    const [paciente, setPaciente] = useState("");
    const [turno, setTurno] = useState("");
    const [fechaDesde, setFechaDesde] = useState("");
    const [fechaHasta, setFechaHasta] = useState("");
    const [turnos, setTurnos] = useState([]);
    const [loading, setLoading] = useState(false);

    const periodoOptions = useMemo(() => monthOptions
        .filter((option) => option.value)
        .map((option) => {
            const value = `${anio}-${option.value}`;
            return {
                value,
                label: `${value} (${getPeriodoRango(value)})`,
            };
        }), [anio]);

    const cargarResumen = useCallback(async () => {
        if (!auxiliar?.id) return;

        setLoading(true);
        setTurnos([]);

        const mesesConsulta = mes
            ? [mes]
            : monthOptions.filter((option) => option.value).map((option) => option.value);

        try {
            const responses = await Promise.all(
                mesesConsulta.map((mesPeriodo) =>
                    axiosInstance.get("/turnos/detalle-auxiliar", {
                        params: {
                            periodo: `${anio}-${mesPeriodo}`,
                            auxiliarID: auxiliar.id,
                        }
                    })
                )
            );

            const rows = responses.flatMap((resp, index) => {
                const periodo = `${anio}-${mesesConsulta[index]}`;
                return (resp.data.turnos?.turnos || []).map((item) => ({
                    ...item,
                    periodoResumen: periodo,
                    totalAuxiliar: getTotalTurnoAuxiliar(item),
                }));
            });

            setTurnos(rows);
        } catch (error) {
            console.error("Error al cargar resumen anual de turnos:", error);
            gdAlertify.notiError("No se pudo cargar el resumen de turnos.");
        } finally {
            setLoading(false);
        }
    }, [auxiliar, anio, mes]);

    useEffect(() => {
        if (isOpen) {
            setPaciente("");
            setTurno("");
            setFechaDesde("");
            setFechaHasta("");
            setPeriodoDesde("");
            setPeriodoHasta("");
            cargarResumen();
        }
    }, [isOpen, cargarResumen]);

    const pacientes = useMemo(() => {
        const map = new Map();
        turnos.forEach((item) => {
            if (item.pacienteID && item.pacienteNombre) {
                map.set(String(item.pacienteID), item.pacienteNombre);
            }
        });
        return Array.from(map, ([value, label]) => ({ value, label }))
            .sort((a, b) => a.label.localeCompare(b.label));
    }, [turnos]);

    const turnosFiltrados = useMemo(() => {
        return turnos.filter((item) => {
            if (periodoDesde && item.periodoResumen < periodoDesde) return false;
            if (periodoHasta && item.periodoResumen > periodoHasta) return false;
            if (paciente && String(item.pacienteID) !== String(paciente)) return false;
            if (turno && item.tipo !== turno) return false;
            if (fechaDesde && item.fecha < fechaDesde) return false;
            if (fechaHasta && item.fecha > fechaHasta) return false;
            return true;
        });
    }, [turnos, periodoDesde, periodoHasta, paciente, turno, fechaDesde, fechaHasta]);

    const kpis = useMemo(() => {
        const totalNeto = turnosFiltrados.reduce((sum, item) => sum + Number(item.totalAuxiliar || 0), 0);
        const pacientesUnicos = new Set(turnosFiltrados.map((item) => item.pacienteID).filter(Boolean)).size;
        const diasUnicos = new Set(turnosFiltrados.map((item) => item.fecha).filter(Boolean)).size;
        const porPeriodo = turnosFiltrados.reduce((acc, item) => {
            acc[item.periodoResumen] = (acc[item.periodoResumen] || 0) + 1;
            return acc;
        }, {});
        const periodoTop = Object.entries(porPeriodo).sort((a, b) => b[1] - a[1])[0];

        return {
            totalTurnos: turnosFiltrados.length,
            totalNeto,
            pacientesUnicos,
            diasUnicos,
            promedioTurno: turnosFiltrados.length ? totalNeto / turnosFiltrados.length : 0,
            periodoTop: periodoTop ? `${periodoTop[0]} (${periodoTop[1]})` : "-",
        };
    }, [turnosFiltrados]);

    const graficoMeses = useMemo(() => {
        const resumen = monthOptions
            .filter((option) => option.value)
            .map((option) => {
                const periodo = `${anio}-${option.value}`;
                const rows = turnosFiltrados.filter((item) => item.periodoResumen === periodo);
                const dia = rows.filter((item) => item.tipo === "day").length;
                const noche = rows.filter((item) => item.tipo === "night").length;

                return {
                    periodo,
                    label: monthNames[option.value],
                    dia,
                    noche,
                    total: dia + noche,
                };
            });

        return {
            labels: resumen.map((item) => item.label),
            datasets: [
                {
                    label: "Dia",
                    data: resumen.map((item) => item.dia),
                    backgroundColor: "rgba(220, 53, 69, 0.8)",
                    borderColor: "rgba(220, 53, 69, 1)",
                    borderWidth: 1,
                    borderRadius: 4,
                },
                {
                    label: "Noche",
                    data: resumen.map((item) => item.noche),
                    backgroundColor: "rgba(13, 110, 253, 0.8)",
                    borderColor: "rgba(13, 110, 253, 1)",
                    borderWidth: 1,
                    borderRadius: 4,
                },
            ],
        };
    }, [anio, turnosFiltrados]);

    const graficoOptions = useMemo(() => ({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: { position: "top" },
            tooltip: {
                callbacks: {
                    afterTitle: (items) => {
                        const index = items?.[0]?.dataIndex ?? 0;
                        const mesGrafico = String(index + 1).padStart(2, "0");
                        return `Periodo: ${getPeriodoRango(`${anio}-${mesGrafico}`)}`;
                    }
                }
            }
        },
        scales: {
            x: { stacked: true, grid: { display: false } },
            y: { stacked: true, beginAtZero: true, ticks: { precision: 0 } },
        },
    }), [anio]);

    if (!isOpen) return null;

    const yearOptions = Array.from({ length: 7 }, (_, index) => currentYear - 4 + index);

    return (
        <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="resumenAnualTurnosModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <div>
                            <h5 className="modal-title" id="resumenAnualTurnosModalLabel">
                                Resumen anual de turnos
                            </h5>
                            <div className="text-muted small">{auxiliar?.nombreAuxiliar || ""}</div>
                        </div>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="row g-2 mb-3">
                            <div className="col-md-2">
                                <label className="form-label">Ano</label>
                                <select className="form-control" value={anio} onChange={(e) => setAnio(Number(e.target.value))}>
                                    {yearOptions.map((year) => (
                                        <option value={year} key={year}>{year}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-2">
                                <label className="form-label">Mes</label>
                                <select className="form-control" value={mes} onChange={(e) => setMes(e.target.value)}>
                                    {monthOptions.map((option) => (
                                        <option value={option.value} key={option.value}>{option.label}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Periodo desde</label>
                                <select className="form-control" value={periodoDesde} onChange={(e) => setPeriodoDesde(e.target.value)}>
                                    <option value="">Todos</option>
                                    {periodoOptions.map((option) => (
                                        <option value={option.value} key={option.value}>{option.label}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Periodo hasta</label>
                                <select className="form-control" value={periodoHasta} onChange={(e) => setPeriodoHasta(e.target.value)}>
                                    <option value="">Todos</option>
                                    {periodoOptions.map((option) => (
                                        <option value={option.value} key={option.value}>{option.label}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Paciente</label>
                                <select className="form-control" value={paciente} onChange={(e) => setPaciente(e.target.value)}>
                                    <option value="">Todos</option>
                                    {pacientes.map((option) => (
                                        <option value={option.value} key={option.value}>{option.label}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-md-2">
                                <label className="form-label">Turno</label>
                                <select className="form-control" value={turno} onChange={(e) => setTurno(e.target.value)}>
                                    <option value="">Todos</option>
                                    <option value="day">Dia</option>
                                    <option value="night">Noche</option>
                                </select>
                            </div>
                            <div className="col-md-2 d-flex align-items-end">
                                <button className="btn btn-primary w-100" type="button" onClick={cargarResumen} disabled={loading}>
                                    {loading ? "Cargando..." : "Actualizar"}
                                </button>
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Fecha desde</label>
                                <input type="date" className="form-control" value={fechaDesde} onChange={(e) => setFechaDesde(e.target.value)} />
                            </div>
                            <div className="col-md-3">
                                <label className="form-label">Fecha hasta</label>
                                <input type="date" className="form-control" value={fechaHasta} onChange={(e) => setFechaHasta(e.target.value)} />
                            </div>
                        </div>

                        <div className="row g-2 mb-3">
                            <div className="col-md-2">
                                <div className="border rounded p-2 h-100 bg-danger bg-opacity-10 border-danger">
                                    <div className="text-muted small">Turnos</div>
                                    <div className="fw-bold fs-5 text-danger">{kpis.totalTurnos}</div>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="border rounded p-2 h-100 bg-primary bg-opacity-10 border-primary">
                                    <div className="text-muted small">Promedio turno</div>
                                    <div className="fw-bold fs-5 text-primary">${formatMoney(kpis.promedioTurno)}</div>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="border rounded p-2 h-100 bg-info bg-opacity-10 border-info">
                                    <div className="text-muted small">Pacientes</div>
                                    <div className="fw-bold fs-5 text-info">{kpis.pacientesUnicos}</div>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="border rounded p-2 h-100 bg-warning bg-opacity-10 border-warning">
                                    <div className="text-muted small">Dias trabajados</div>
                                    <div className="fw-bold fs-5 text-warning">{kpis.diasUnicos}</div>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="border rounded p-2 h-100 bg-secondary bg-opacity-10 border-secondary">
                                    <div className="text-muted small">Periodo mayor</div>
                                    <div className="fw-bold text-secondary">{kpis.periodoTop}</div>
                                </div>
                            </div>
                        </div>

                        <div className="border rounded p-3 mb-3">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <div>
                                    <div className="fw-bold">Turnos por mes</div>
                                    <div className="text-muted small">Cada mes corresponde al periodo 26 del mes anterior al 25 del mes actual.</div>
                                </div>
                                <div className="text-muted small">
                                    {mes ? `${monthNames[mes]}: ${getPeriodoRango(`${anio}-${mes}`)}` : `Ano ${anio}`}
                                </div>
                            </div>
                            <div style={{ height: 260 }}>
                                <Bar data={graficoMeses} options={graficoOptions} />
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-sm table-striped align-middle">
                                <thead>
                                    <tr>
                                        <th>Periodo</th>
                                        <th>Rango periodo</th>
                                        <th>Fecha</th>
                                        <th>Dia</th>
                                        <th>Turno</th>
                                        <th>Paciente</th>
                                        <th className="text-end">Valor</th>
                                        <th className="text-end">Colacion</th>
                                        <th className="text-end">Movilizacion</th>
                                        <th className="text-end">Otro</th>
                                        <th>Nota</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="11" className="text-center text-muted py-4">Cargando resumen...</td>
                                        </tr>
                                    ) : turnosFiltrados.length > 0 ? (
                                        turnosFiltrados.map((item, index) => (
                                            <tr key={`${item.periodoResumen}-${item.pacienteID}-${item.fecha}-${item.tipo}-${index}`}>
                                                <td>{item.periodoResumen}</td>
                                                <td className="text-nowrap small">{getPeriodoRango(item.periodoResumen)}</td>
                                                <td>{formatDate(item.fecha)}</td>
                                                <td>{diaMap[item.diaSemana] || item.diaSemana || "-"}</td>
                                                <td>
                                                    <span className={`badge ${item.tipo === "night" ? "bg-primary" : "bg-danger"}`}>
                                                        {item.tipo === "night" ? "Noche" : "Dia"}
                                                    </span>
                                                </td>
                                                <td>{item.pacienteNombre}</td>
                                                <td className="text-end">${formatMoney(getValorTurnoActual(item))}</td>
                                                <td className="text-end">${formatMoney(getValorColacionActual(item))}</td>
                                                <td className="text-end">${formatMoney(getValorMovilizacionActual(item))}</td>
                                                <td className="text-end">${formatMoney(getValorOtroActual(item))}</td>
                                                <td>{item.notes || item.notas_internas || "-"}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="11" className="text-center text-muted py-4">No hay turnos para los filtros seleccionados.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const NominaAuxiliares = () => {
    const [auxiliarEditarId, setAuxiliarEditarId] = useState(null);
    const [actualizacion, setActualizacion] = useState(0);
    const alGuardarAuxiliar = () => {
        setAuxiliarEditarId(null);
        setActualizacion(prev => prev + 1);
    };
    const [resultados, setResultados] = useState([]); // Estado para almacenar los auxiliares obtenidos.
    const [selectedAuxiliar, setSelectedAuxiliar] = useState(null);
    const [history, setHistory] = useState({}); // Estado para almacenar los historiales de los auxiliares.

    const [isObservationModalOpen, setIsObservationModalOpen] = useState(false);
    const [selectedAuxiliarForObservation, setSelectedAuxiliarForObservation] = useState(null);

    const [isVacacionesModalOpen, setIsVacacionesModalOpen] = useState(false);
    const [auxiliarForVacaciones, setAuxiliarForVacaciones] = useState(null);
    const [isRetirosModalOpen, setIsRetirosModalOpen] = useState(false);
    const [auxiliarForRetiros, setAuxiliarForRetiros] = useState(null);
    const [historialRetiros, setHistorialRetiros] = useState([]);
    const [loadingRetiros, setLoadingRetiros] = useState(false);
    const [isResumenTurnosModalOpen, setIsResumenTurnosModalOpen] = useState(false);
    const [auxiliarForResumenTurnos, setAuxiliarForResumenTurnos] = useState(null);
    const [isExportModalOpen, setIsExportModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        gdAlertify.showLoader()
        setLoading(true);
        async function buscarAuxiliares() {
            try {
                const params = { detalle_extendido: 0, cordinacion: true };
                const response = await axiosInstance.get("/auxiliar/busqueda", { params });
                setResultados(response.data.data); // Almacena los resultados en el estado.
                gdAlertify.hideLoader()
            } catch (error) {
                gdAlertify.hideLoader()
                console.error("Error al buscar auxiliares: ", error);
            } finally {
                setLoading(false);
            }
        };
        buscarAuxiliares();
    }, [actualizacion]);

    const handleViewHistory = async (auxiliarID) => {
        try {
            const response = await axiosInstance.get(`/auxiliar/${auxiliarID}/historial`);
            setHistory((prev) => ({ ...prev, [auxiliarID]: response.data.data }));
            setSelectedAuxiliar(auxiliarID);
        } catch (error) {
            console.error("Error al obtener el historial del auxiliar: ", error);
        }
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [detalleAuxiliar, setDetalleAuxiliar] = useState(null);
    const [obsercaionesAuxiliar, setObservacionesAuxiliar] = useState(null);

    const verHistorial = useCallback(async (idAuxiliar) => {
        setIsModalOpen(true);
        setDetalleAuxiliar(null);
        const params = { idAuxiliar };
        try {
            const response = await axiosInstance.get("/auxiliar/historial", { params });
            setDetalleAuxiliar(response.data.data.historial);
            setObservacionesAuxiliar(response.data.data.observaciones);
        } catch (error) {
            console.error(error);
            setDetalleAuxiliar({ error: "No se pudo cargar la información" });
        }
    }, []);

    const handleAddObservation = useCallback((auxiliarID) => {
        setSelectedAuxiliarForObservation(auxiliarID);
        setIsObservationModalOpen(true);
    }, []);

    const verHistorialRetiros = useCallback(async (auxiliar) => {
        setAuxiliarForRetiros(auxiliar);
        setHistorialRetiros([]);
        setIsRetirosModalOpen(true);
        setLoadingRetiros(true);

        try {
            const response = await axiosInstance.get("/auxiliar/busqueda", {
                params: {
                    idAuxiliar: auxiliar.id,
                    detalle_extendido: 1
                }
            });
            const detalle = response.data.data?.[0];
            setHistorialRetiros(detalle?.historialEstadoLaboral || []);
        } catch (error) {
            console.error("Error al obtener historial de retiros:", error);
            gdAlertify.notiError("No se pudo cargar el historial de retiros.");
        } finally {
            setLoadingRetiros(false);
        }
    }, []);

    const columns = [
        {
            name: "id",
            title: "Acción",
            render: (row) => {
                return (
                    <div className="dropdown">
                        <button
                            className="btn btn-sm btn-primary dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                        >
                            Acciones
                        </button>

                        <ul className="dropdown-menu">

                            {/* Editar */}
                            <li>
                                <button
                                    className="dropdown-item text-primary"
                                    onClick={() => setAuxiliarEditarId(row.id)}
                                >
                                    <i className="bi bi-pencil-square me-2"></i>
                                    Editar
                                </button>
                            </li>

                            {/* Ver Historial */}
                            <li>
                                <button
                                    className="dropdown-item text-success"
                                    onClick={() => verHistorial(row.id)}
                                >
                                    <i className="bi bi-clock-history me-2"></i>
                                    Ver Historial
                                </button>
                            </li>

                            {/* Agregar Observación */}
                            <li>
                                <button
                                    className="dropdown-item text-secondary"
                                    onClick={() => handleAddObservation(row.id)}
                                >
                                    <i className="bi bi-chat-left-text me-2"></i>
                                    Agregar Observación
                                </button>
                            </li>

                            {/* Vacaciones */}
                            <li>
                                <button
                                    className="dropdown-item text-success"
                                    onClick={() => {
                                        setAuxiliarForVacaciones(row);
                                        setIsVacacionesModalOpen(true);
                                    }}
                                >
                                    <i className="bi bi-calendar-check me-2"></i>
                                    Vacaciones
                                </button>
                            </li>

                            {/* Historial de Retiros */}
                            <li>
                                <button
                                    className="dropdown-item text-warning"
                                    onClick={() => verHistorialRetiros(row)}
                                >
                                    <i className="bi bi-box-arrow-right me-2"></i>
                                    Historial de Retiros
                                </button>
                            </li>

                            {/* Resumen anual de turnos */}
                            <li>
                                <button
                                    className="dropdown-item text-info"
                                    onClick={() => {
                                        setAuxiliarForResumenTurnos(row);
                                        setIsResumenTurnosModalOpen(true);
                                    }}
                                >
                                    <i className="bi bi-bar-chart-line me-2"></i>
                                    Resumen anual turnos
                                </button>
                            </li>

                        </ul>
                    </div>
                );
            },
            width: 100
        },
        { 
            name: "nombreAuxiliar", 
            title: "Nombre de Auxiliar", 
            width: 300,
            render: (row) => (
                <div className="d-flex align-items-center">
                    {row.nombreAuxiliar}
                    {row.en_vacaciones > 0 && (
                        <span className="badge bg-success ms-2" title="En Vacaciones">
                            <i className="bi bi-calendar-check me-1"></i>
                            Vacaciones
                        </span>
                    )}
                </div>
            )
        },
        { name: 'tipoDocumento', title: 'Tipo de RUT', width: 150, render: (row) => {
            const map = {
                'RUT': 'RUT',
                'rutProvisorio': 'RUT provisorio',
                'Pasaporte': 'Pasaporte',
                'rutExtranjero': 'RUT extranjero'
            };
            return map[row.tipoDocumento] || row.tipoDocumento || 'RUT';
        }},
        { name: 'ultimoAcuerdoActivo', title: 'Último Acuerdo Activo', width: 200, render: (row) => row.ultimoAcuerdoActivo || 'Sin acuerdo' },
        { name: 'celular', title: 'Celular', width: 100 },
        { name: 'fechaIngreso', title: 'Fecha de Ingreso', render: (row) => formatDate(row.fechaIngreso), width: 100 },
        { name: 'fechaNacimiento', title: 'Edad', render: (row) => calculateAge(row.fechaNacimiento), width: 100 },
        { name: 'nacionalidad', title: 'Nacionalidad', render: (row) => row.nacionalidad || '-', width: 150 },
        { name: 'direccion', title: 'Dirección', render: (row) => (row.direccion), width: 200 },
        { name: 'des_comuna', title: 'Comuna', render: (row) => (row.des_comuna), width: 200 },
        { name: 'clasificacionID', title: 'Clasificación', render: (row) => clasificacionMap[row.clasificacionID], getFilterValue: (row) => clasificacionMap[row.clasificacionID], width: 200 },
        { name: 'des_categoria', title: 'Categorización', width: 100 },
        {
            name: "id",
            title: "Acción",
            render: (row) => {
                return (
                    <button className="btn btn-primary" onClick={() => setAuxiliarEditarId(row.id)}>
                        Editar
                    </button>
                )
            },
            width: 100
        },
        {
            name: "id",
            title: "Acción",
            render: (row) => {
                return (
                    <button className="btn btn-success" onClick={() => verHistorial(row.id)}>
                        Ver Historial
                    </button>
                )
            },
            width: 100
        },
        {
            name: "id",
            title: "Acción",
            render: (row) => {
                return (
                    <button className="btn btn-secondary" onClick={() => handleAddObservation(row.id)}>
                        Agregar Observación
                    </button>
                )
            },
            width: 100
        },
    ]
    return (
        <div className="container-fluid mt-5">
            <div className="card p-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h3 className="mb-0">Nomina de Auxiliares</h3>
                    <button className="btn btn-success" onClick={() => setIsExportModalOpen(true)}>
                        <i className="bi bi-file-earmark-excel me-1"></i>
                        Exportar Datos
                    </button>
                </div>

                {/* Tabla principal */}
                <GdTable
                    columns={columns}
                    data={resultados}
                    defaultItemsPerPage={100}
                    itemsPerPageOptions={[5, 10, 25, 50, 100]}
                    initialSort={[0, "asc"]}
                    loading={loading}
                    showCsvExport={false}
                    exportFilename="nomina-auxiliares.xlsx"
                />
            </div>
            <EditarAuxiliarModal
                isOpen={auxiliarEditarId !== null}
                auxiliarId={auxiliarEditarId}
                onClose={() => setAuxiliarEditarId(null)}
                onSaved={alGuardarAuxiliar}
                anchoLimitado
            />
            {/* Modales */}
            <DetalleAuxiliar
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                details={detalleAuxiliar}
                observaciones={obsercaionesAuxiliar}
            />
            <ObservationModal
                isOpen={isObservationModalOpen}
                onClose={() => setIsObservationModalOpen(false)}
                auxiliarID={selectedAuxiliarForObservation}
            />
            <VacacionesModal
                isOpen={isVacacionesModalOpen}
                onClose={() => setIsVacacionesModalOpen(false)}
                auxiliarID={auxiliarForVacaciones?.id}
                nombreAuxiliar={auxiliarForVacaciones?.nombreAuxiliar}
            />
            <HistorialRetirosModal
                isOpen={isRetirosModalOpen}
                onClose={() => setIsRetirosModalOpen(false)}
                auxiliar={auxiliarForRetiros}
                historial={historialRetiros}
                loading={loadingRetiros}
            />
            <ResumenAnualTurnosModal
                isOpen={isResumenTurnosModalOpen}
                onClose={() => setIsResumenTurnosModalOpen(false)}
                auxiliar={auxiliarForResumenTurnos}
            />
            <ExportarAuxiliaresModal
                isOpen={isExportModalOpen}
                onClose={() => setIsExportModalOpen(false)}
                totalAuxiliares={resultados.length}
            />
        </div>
    );
};

export default NominaAuxiliares;
